import React from 'react';
import {useNavigate} from 'react-router-dom';

const InfoIcon = ({active}) => {
    const fill = active ? '#BC88FC' : '#ffffff';
    return (
        <svg width="11" height="31" viewBox="0 0 11 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_1_785" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="11" height="31">
                <rect width="10.0909" height="30.2324" fill={fill}/>
            </mask>
            <g mask="url(#mask0_1_785)">
                <path d="M6.41782 1.0283C7.11746 1.71448 7.46728 2.56884 7.46728 3.59139C7.46728 4.58703 7.11746 5.42794 6.41782 6.11412C5.71819 6.8003 4.83019 7.14339 3.75382 7.14339C2.67746 7.14339 1.78273 6.8003 1.06964 6.11412C0.356546 5.42794 0 4.58703 0 3.59139C0 2.56884 0.356546 1.71448 1.06964 1.0283C1.78273 0.342115 2.67746 -0.000976562 3.75382 -0.000976562C4.83019 -0.000976562 5.71819 0.342115 6.41782 1.0283ZM0.888001 9.48448H6.61964V30.2314H0.888001V9.48448Z" fill={fill}/>
            </g>
        </svg>
    );
};

const ShareIcon = ({active}) => {
    const fill = active ? '#BC88FC' : '#ffffff';
    return (
        <svg width="32" height="27" viewBox="0 0 42 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_1_787" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="42" height="36">
                <rect width="41.7878" height="35.112" fill={fill}/>
            </mask>
            <g mask="url(#mask0_1_787)">
                <path d="M41.7878 18.6411C35.1501 18.6411 22.4565 11.3817 22.4565 0H26.3175C26.3175 9.04348 37.1958 14.7801 41.7878 14.7801V18.6411Z" fill={fill}/>
                <path d="M26.3175 33.4203H22.4565C22.4565 28.3916 25.0403 23.5479 29.731 19.7813C33.5154 16.7431 38.2479 14.7802 41.7878 14.7802V18.6411C37.1958 18.6411 26.3175 24.3768 26.3175 33.4203Z" fill={fill}/>
                <path d="M22.4565 0.000183105L22.4041 33.4418L34.5729 16.7103L22.4565 0.000183105Z" fill={fill}/>
                <path d="M27.8588 15.9666L22.4556 9.89822C-3.50702 9.14934 0.180459 35.112 0.180459 35.112C0.180459 35.112 6.11102 20.3674 22.404 23.3051L27.8588 15.9666Z" fill={fill}/>
            </g>
        </svg>
    );
};

const HomeIcon = ({active}) => {
    const fill = active ? '#BC88FC' : '#ffffff';
    return (
        <svg width="28" height="25" viewBox="0 0 38 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 16.19V13.161C7.531 13.161 17.082 1.894 17.269 0L20.298 0.0199995C20.298 3.752 9.026 16.19 0 16.19Z" fill={fill}/>
            <path d="M37.5658 16.19C28.5398 16.19 17.2678 3.75202 17.2678 0.0200195H20.2978C20.4838 1.89402 30.0348 13.161 37.5658 13.161V16.19Z" fill={fill}/>
            <path d="M17.9318 3.45204L4.72384 14.031C4.40284 14.284 4.21484 14.671 4.21484 15.081V31.101C4.21484 32.298 5.18684 33.268 6.38384 33.268H12.4058C12.7618 33.268 13.1018 33.127 13.3528 32.876C13.6028 32.625 13.7448 32.285 13.7448 31.93V22.146C13.7448 21.409 14.3428 20.808 15.0828 20.808H22.4828C22.8388 20.808 23.1778 20.949 23.4288 21.2C23.6798 21.451 23.8208 21.791 23.8208 22.146V31.922C23.8208 32.277 23.9618 32.617 24.2128 32.868C24.4638 33.119 24.8038 33.26 25.1598 33.26H31.1818C32.3788 33.26 33.3508 32.29 33.3508 31.093V15.081C33.3488 14.668 33.1548 14.281 32.8288 14.03L19.6208 3.45104C19.1288 3.05204 18.4238 3.05204 17.9318 3.45104V3.45204Z" fill={fill}/>
        </svg>
    );
};

const BottomNav = ({activeIcon, onInfoClick, onShareClick, onClose}) => {
    const navigate = useNavigate();

    const handleInfo = (e) => { e.stopPropagation(); onClose?.(); onInfoClick?.(); };
    const handleHome = (e) => { e.stopPropagation(); onClose?.(); navigate('/locations/5'); };
    const handleShare = (e) => { e.stopPropagation(); onClose?.(); onShareClick?.(); };

    return (
        <nav id="bottom-nav">
            <button onClick={handleInfo}>
                <InfoIcon active={activeIcon === 'info'}/>
            </button>
            <button onClick={handleHome}>
                <HomeIcon active={activeIcon === 'home'}/>
            </button>
            <button onClick={handleShare}>
                <ShareIcon active={activeIcon === 'share'}/>
            </button>
        </nav>
    );
};

export default BottomNav;
